import { AppPage } from '@launchpad';
import React from 'react';
import StipLogStats from '../components/StipLogsStats';
import StipLogsReports from '../components/StipLogsReports';

const StipLogsDashboard = (props) => {
  return (
    <AppPage title="STIP dashboard" icon="list">
      <div className="row">
        <div className="col-sm-6">
          <StipLogStats />
        </div>
        <div className="col-sm-6">
          <StipLogsReports />
        </div>
      </div>
    </AppPage>
  );
};

export default StipLogsDashboard;
